module.exports = __webpack_public_path__ + "do.svg?34a43d3ce2bcc7c5fcf4388dde856271";